<template src="./template.html"></template>

<script>
import Promise from 'bluebird'
import { mapState } from 'vuex'
import _find from 'lodash/find'

import orderCartService from 'api/orderCart'
import store from 'store'
import * as mutationTypes from 'store/mutationTypes'
import dateUtils from 'utils/dateUtils'

export default {
  name: 'order-cart',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      date: (state) => state.date.current,
      venue: (state) => state.venue.current,
      items: (state) => state.checkout.items,
      daySettings: (state) => state.daySettings.current,
    }),
    itemSubtotal() {
      if (!this.priceCart) return 0

      return this.priceCart.subtotal
    },
    venueAcceptingOrders() {
      return !!(this.daySettings || {}).acceptingOrders
    },
  },
  data() {
    return {
      loading: false,
      priceCart: null,
    }
  },
  watch: {
    visible() {
      if (this.visible) {
        this.priceCartItems()
      }
    },
  },
  methods: {
    getItemKey(item, key) {
      if (!this.priceCart || !this.priceCart.items) return item.total

      const cartItem = _find(this.priceCart.items, (c) => {
        return c.inventory.id === item.inventoryId
      })

      if (cartItem) {
        return cartItem[key]
      }

      return item.total
    },
    onItemQuantityChanged(item, $event) {
      const previousItemQuantity = item.quantity

      item.quantity = $event.target.value

      this.priceCartItems()
        .then(() => {
          return null
        })
        .catch((error) => {
          this.$store.dispatch('addTopBarNotification', {
            text: error.message,
          })

          item.quantity = previousItemQuantity

          return null
        })
    },
    getItemWeight(item) {
      if (item.inventory && item.inventory.weights) {
        const matchingWeight = _find(item.inventory.weights, {
          id: item.inventoryId,
        })

        return matchingWeight ? matchingWeight.weightFormatted : item.inventory.weightFormatted
      }

      return item.inventory.weightFormatted
    },
    removeCartItem(inventoryId) {
      this.$store
        .dispatch('removeCartItem', inventoryId)
        .then(() => {
          if (!this.items || !this.items.length) return null

          return this.priceCartItems()
        })
        .then(() => {
          return null
        })
        .catch((error) => {
          this.$store.dispatch('addTopBarNotification', {
            text: error.message,
          })

          return null
        })
    },
    checkout() {
      if (!this.venueAcceptingOrders) {
        console.log('no orders') //eslint-disable-line
      }

      this.$emit('closeModal')

      this.$router.push({
        name: 'OrderAndCheckoutAppCheckout',
      })
    },
    onMutation(mutation) {
      if (mutation.type === mutationTypes.ADD_CART_ITEM && this.visible) {
        this.priceCartItems()
          .then(() => {
            return null
          })
          .catch((error) => {
            this.$store.dispatch('addTopBarNotification', {
              text: error.message,
            })

            return null
          })
      }
    },
    priceCartItems() {
      if (!this.items || !this.items.length) return Promise.resolve()

      this.loading = true

      return orderCartService
        .createByVenueId(this.venue.id, {
          date: dateUtils.toUTCTimestampWithoutTime(this.date),
          items: this.items.map((i) => {
            return {
              inventoryId: i.inventoryId,
              quantity: parseInt(i.quantity, 10),
            }
          }),
        })
        .then((result) => {
          this.priceCart = result.data

          this.loading = false
        })
        .catch((err) => {
          this.loading = false

          throw err
        })
    },
  },
  created() {
    this.storeUnsubscribe = store.subscribe(this.onMutation)

    this.priceCartItems()
      .then(() => {
        return null
      })
      .catch((error) => {
        this.$store.dispatch('addTopBarNotification', {
          text: error.message,
        })

        return null
      })
  },
  destroyed() {
    if (this.storeUnsubscribe) this.storeUnsubscribe()
  },
}
</script>



// WEBPACK FOOTER //
// src/components/OrderCart/index.vue